import React, { useCallback, useState } from 'react'
import { useText } from '../context/TextContext';
import { PATHS } from '../utils/shared/constants';
import { Article } from '../models/shared/Article';
import SearchInput from './SearchInput';
import { useNavigate } from 'react-router-dom';
import { AdvancedButton } from './AdvancedButton';
import { calculatePriceWithVat, formatPrice } from '../utils/shared/priceCalculator';

interface Props {
    articles: Article[];
    onArticleSelect: (article: Article) => void;
    disabled?: boolean;
    className?: string;
    placeholder?: string;
    autoFocus?: boolean;
}

export default function ArticleSearch(props: Props) {
    const { onArticleSelect, disabled, className, placeholder, articles } = props;
    const text = useText();
    const navigate = useNavigate();
    const [query, setQuery] = useState('');

    // Function to search for articles locally and always return results
    const searchArticles = useCallback(async (query: string) => {
        if (!query) return articles; // Return all articles if no query

        const lowerQuery = query.toLowerCase();
        return articles.filter(article =>
            article.name.toLowerCase().includes(lowerQuery)
        );
    }, [articles]);

    // Handle form submission (create new article)
    const onSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        console.log('onSubmit', e);
        e.preventDefault();
        const params = new URLSearchParams({
            returnTo: window.location.pathname,
            initialName: query
        });
        navigate(`${PATHS.ARTICLES_EDIT}?${params.toString()}`);
    };



    if (disabled) {
        return null;
    }

    return (
        <form onSubmit={onSubmit} className={className}>
            <SearchInput
                instantSearch
                resetOnBlur
                noSpinner
                autoFocus={props.autoFocus}
                size="sm"
                searchCallback={searchArticles}
                onChange={setQuery}
                renderCandidate={(article) => (
                    <div className='py-1'>
                        <div>{article.name}</div>
                        <div className="opacity-75 small">
                            {text.priceWithVat}: {formatPrice(calculatePriceWithVat(article.perUnitPrice, article.vatRate))}
                        </div>
                    </div>
                )}
                handleSelect={(article) => {
                    return Promise.resolve(onArticleSelect(article));
                }}
                placeHolder={placeholder || text.searchArticle}
                onCancel={() => { }}
                minCharacters={0} // Always show results when focused
                renderEmpty={() => (
                    <div className='px-3 py-2'>
                        <div className='text-muted'>{text.noResults}</div>
                    </div>
                )}
                renderFooter={() => (
                    <div className="center border-top py-2">
                        <AdvancedButton
                            type='submit'
                            // onClick={handleAddNewArticle}
                            size='sm'
                            variant='clear'
                            icon='bi-plus'
                        >
                            {text.createNewArticle}
                        </AdvancedButton>
                    </div>
                )}
            />
        </form>
    );
}
